export default {
  bookExperiencePanel: '預訂體驗面板',
  calendarIcon: '日曆圖示',
  coverImageForResource: '{{title}} 體驗的封面圖片',
  filterBy: '按 {{filter}} 篩選',
  filterByDateRange: '按日期範圍篩選',
  gallery: '圖庫',
  goBack: '返回上一頁',
  hostUserIcon: '主持人圖示',
  imageOf: '{{title}} 的圖片',
  interactiveMapAltText: '包含可選擇的 {{title}} 的互動地圖',
  mediaSlides: '媒體投影片',
  muteVideo: '靜音影片',
  nextPhoto: '下一張照片',
  noVideoPlayback: '無法播放影片',
  pauseVideo: '暫停影片',
  photoOf: '{{name}} 的照片',
  playVideo: '播放影片',
  previousPhoto: '上一張照片',
  reserveSelectedSlot: '預約選定時段',
  selectDate: '選擇日期',
  selectParticipants: '選擇參加者',
  selectSessionTime: '選擇時段',
  unmuteVideo: '取消靜音影片',
  viewShoppingCart: '查看購物車',
  zoomIn: '放大',
  zoomOut: '縮小',
  selectData: '選擇 {{data}}',
  reserveName: '預訂 {{name}}',
  deleteReservation: '刪除 {{experienceTitle}} 預訂',
  editParticipantsFor: '編輯 {{experienceTitle}} 的參加者',
  enterPromoCode: '輸入優惠碼',
  applyPromoCode: '套用優惠碼',
  increaseAddOnAmount: '增加 {{addOn}} 選項',
  decreaseAddOnAmount: '減少 {{addOn}} 選項',
  addOnModal: '{{addOn}} 選項視窗',
  moreInformationAboutAddOn: '更多關於 {{addOn}} 的資訊',
  decreasePriceTierTickets: '減少 {{priceTier}} 票數',
  increasePriceTierTickets: '增加 {{priceTier}} 票數',
  downloadFilename: '下載 {{filename}}',
  viewFullDetailsDescription: '查看完整詳細資訊',
  viewFullDescription: '查看完整描述',
  closeModal: '關閉視窗',
};
